import { Images } from "../components/Images";

export const Home = () => {
  return (
    <>
      <Images />
    </>
  );
};
